import {useAppSelector} from '../../../../hooks/react-redux'
import {objectEntries} from '../../../../utils/object'
import {GlobalSearchKind} from '../Shortcuts.types'

import {useSearchShortcutEffect} from './useSearchShortcutEffect'

export const useSearchShortcutSidebar = () => {
  useSearchShortcutEffect({
    kind: GlobalSearchKind.SIDEBAR,
  })

  return useAppSelector(state =>
    objectEntries(state.shortcuts.globalSearch).every(
      ([kind, value]) => kind === GlobalSearchKind.SIDEBAR || value.count === 0,
    ),
  )
}
